import { Fragment, type ComponentChildren } from 'preact';
import type { RichTextBlock, RichTextDoc, RichTextInline, RichTextListItem } from 'shared';

/** The dealer's formatted description. Blank paragraphs are dropped; `gap` already spaces blocks. */
export function ProductDescription({ doc }: { doc: RichTextDoc }) {
  return <div className="sm-type-body sm-muted sm-description">{doc.content.map(renderBlock)}</div>;
}

function renderBlock(block: RichTextBlock | RichTextListItem, key: number): ComponentChildren {
  switch (block.type) {
    case 'paragraph':
      return block.content?.length ? <p key={key}>{renderInline(block.content)}</p> : null;
    case 'heading':
      return (
        <p key={key} className="sm-type-body-strong sm-description-heading">
          {renderInline(block.content ?? [])}
        </p>
      );
    case 'bulletList':
      return (
        <ul key={key} className="sm-description-list sm-description-bullets">
          {block.content.map(renderBlock)}
        </ul>
      );
    case 'orderedList':
      return (
        <ol
          key={key}
          start={block.attrs?.start}
          className="sm-description-list sm-description-numbers"
        >
          {block.content.map(renderBlock)}
        </ol>
      );
    case 'listItem':
      return <li key={key}>{block.content.map(renderBlock)}</li>;
  }
}

function renderInline(nodes: RichTextInline[]): ComponentChildren {
  return nodes.map((node, i) => {
    if (node.type === 'hardBreak') return <br key={i} />;
    let out: ComponentChildren = node.text;
    for (const mark of node.marks ?? []) {
      out =
        mark.type === 'bold' ? (
          <strong className="sm-description-bold">{out}</strong>
        ) : (
          <em>{out}</em>
        );
    }
    return <Fragment key={i}>{out}</Fragment>;
  });
}
